<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="col-md-8">
                        <div class="header">
                            <h4 class="title"></h4>
                            <p class="category"></p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="text-right">
                            <i class="material-icons" (click)="previewMode()">remove_red_eye</i><!--[routerLink]="['/app/instructions','eli_assessments', assessmentId, 0]"-->
                            <i class="material-icons">content_copy</i>
                            <i (click)="saveAssessment()" class="material-icons">save</i><!--[routerLink]="['/app/eli']"-->
                        </div>
                    </div>
                    <div class="container-fluid c-content">
                        <div class="row">
                            <div class="col-md-1 text-right">
                                <label>Name: </label>
                            </div>
                            <div class="col-md-11">
                                <input #namee
                                       (keypress)="preventSpace(namee.value, $event)"
                                       (keyup)="preventSpace(namee.value, $event)"
                                       type="text" id="name" name="name" value="{{name}}" />
                            </div>
                        </div>

                        <!--<div class="row">
                            <div class="col-md-1 text-right">
                                <label>Niche: </label>
                            </div>
                            <div class="col-md-11">
                                <select #niche id="niche" (change)="selectNiche(niche.value);">
                                    <option *ngFor="let niche of niches" [selected]="nicheName == niche.Name || nicheId == niche.Id" value="{{niche.Id}}">{{niche.Name}}</option>
                                </select>
                            </div>
                        </div>-->

                        <div class="row">
                            <div class="col-md-1 text-right">
                                <label>Version: </label>
                            </div>
                            <div class="col-md-11">
                                <input (keypress)="preventLetters($event)" class="small" type="number" name="name" min="1" value="{{majorVersion}}" id="major" />
                                <span class="dot"><b>.</b></span>
                                <input (keypress)="preventLetters($event)" class="small" type="number" name="name" min="0" value="{{minorVersion}}" id="minor" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-1 text-right">
                                <label>Base ELI: </label>
                            </div>
                            <div class="col-md-11">
                                <select id="baseEli">
                                    <option *ngFor="let b of baseEli" [selected]="regularAssessment == b.Id" value="{{b.Id}}">{{b.Name}}</option>
                                </select>
                            </div>
                        </div>

                        <br />

                        <div class="responsiveTabs">
                            <select #t (change)="openTab(t.value)">
                                <option value="0-section1">Section 1</option>
                                <option value="1-section2">Saection 2</option>
                            </select>
                        </div>

                        <div class="desktopTabs">
                            <ul class="nav nav-tabs">
                                <li (click)="tabSelect(0)" class="active"><a data-toggle="tab" href="#section1">Section 1</a></li>
                                <li (click)="tabSelect(1)"><a data-toggle="tab" href="#section2">Section 2</a></li>
                            </ul>
                        </div>



                        <div class="tab-content">
                            <div id="section1" class="tab-pane fade in active">
                                <div class="text-right absolute">
                                    <i (click)="showQuestions(4)" class="material-icons">add</i>
                                </div>

                                <div class="row">
                                    <div class="col-md-2">
                                        <label>Choice set: </label>
                                    </div>
                                    <div class="col-md-8">
                                        <select id="section1ChoiceSet" #section1ChoiceSet (change)="selectSectionChoiceSet(1, section1ChoiceSet.value)">
                                            <option *ngFor="let choiceSet of section1ChoiceSets" [selected]="section1ChoiceSet == choiceSet.Id" value="{{choiceSet.Id}}">{{choiceSet.Name}}</option>
                                        </select>
                                    </div>
                                </div>

                                <br />

                                <div style="width: 100%; max-height: 400px; height:400px;">
                                    <ag-grid-angular #section1QuestionsGrid
                                                     style="width: 100%; height: 100%;"
                                                     class="ag-theme-balham"
                                                     [enableFilter]="false"
                                                     [gridOptions]="section1GridOptions"
                                                     [rowData]="section1_questions"
                                                     [columnDefs]="section1Headers"
                                                     [enableSorting]="false"
                                                     [enableColResize]="false"
                                                     (rowClicked)="onSection1RowClicked($event)"
                                                     (gridReady)="onSection1GridReady($event)"
                                                     [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                     [animateRows]="true"
                                                     [rowDragManaged]="true"
                                                     (rowDragEnter)="onRowDragEnter($event)"
                                                     (rowDragEnd)="onRowDragEnd($event, section1_questions)">
                                    </ag-grid-angular>
                                </div>
                            </div>
                            <div id="section2" class="tab-pane fade">
                                <div class="text-right absolute">
                                    <i (click)="showQuestions(5)" class="material-icons">add</i>
                                </div>

                                <div class="row">
                                    <div class="col-md-2">
                                        <label>Choice set: </label>
                                    </div>
                                    <div class="col-md-8">
                                        <select id="section2ChoiceSet" #section2ChoiceSet (change)="selectSectionChoiceSet(2, section2ChoiceSet.value)">
                                            <option *ngFor="let choiceSet of section2ChoiceSets" [selected]="section2ChoiceSet == choiceSet.Id" value="{{choiceSet.Id}}">{{choiceSet.Name}}</option>
                                        </select>
                                    </div>
                                </div>

                                <br />

                                <div style="width: 100%; max-height: 400px; height:400px;">
                                    <ag-grid-angular #section2QuestionsGrid
                                                     style="width: 100%; height: 100%;"
                                                     class="ag-theme-balham"
                                                     [enableFilter]="false"
                                                     [gridOptions]="section2GridOptions"
                                                     [rowData]="section2_questions"
                                                     [columnDefs]="section2Headers"
                                                     [enableSorting]="false"
                                                     [enableColResize]="false"
                                                     (rowClicked)="onSection2RowClicked($event)"
                                                     (gridReady)="onSection2GridReady($event)"
                                                     [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                                     [animateRows]="true"
                                                     [rowDragManaged]="true"
                                                     (rowDragEnter)="onRowDragEnter($event)"
                                                     (rowDragEnd)="onRowDragEnd($event, section2_questions)">
                                    </ag-grid-angular>
                                </div>
                            </div>
                        </div>
                        <br />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--MODAL-->
<div class="modal fade" id="questionsModal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h2 class="modal-title text-center" id="">{{questionType}} questions</h2>
            </div>
            <div class="modal-body">
                <div class="" style="width: 100%; max-height: 400px; height:400px;">
                    <ag-grid-angular #questionsGrid
                                     style="width: 100%; height: 100%;"
                                     class="ag-theme-balham"
                                     [enableFilter]="true"
                                     [gridOptions]="questionsGridOptions"
                                     [rowData]="questions"
                                     [columnDefs]="questionsHeaders"
                                     [enableSorting]="true"
                                     [enableColResize]="true"
                                     (rowClicked)="onQuestionsRowClicked($event)"
                                     (gridReady)="onQuestionsGridReady($event)"
                                     [pagination]="true"
                                     [paginationPageSize]="25"
                                     [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                     [rowSelection]="rowSelection">
                    </ag-grid-angular>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="addQuestions()">Add</button>
            </div>
        </div>
    </div>
</div>
